import { render, staticRenderFns } from "./RsaPazienteAreeComponent.vue?vue&type=template&id=d729d2ce"
import script from "./RsaPazienteAreeComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAreeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports